import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function TicketMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path fillRule="evenodd" clipRule="evenodd" d="M2.95 4.95A2.9 2.9 0 015 4.1h14A2.9 2.9 0 0121.9 7v3a.9.9 0 01-.9.9 1.1 1.1 0 100 2.2.9.9 0 01.9.9v3a2.9 2.9 0 01-2.9 2.9H5A2.9 2.9 0 012.1 17v-3a.9.9 0 01.9-.9 1.1 1.1 0 000-2.2.9.9 0 01-.9-.9V7a2.9 2.9 0 01.85-2.05zM5 5.9A1.1 1.1 0 003.9 7v2.243a2.9 2.9 0 010 5.514V17A1.1 1.1 0 005 18.1h9.1V17a.9.9 0 111.8 0v1.1H19a1.1 1.1 0 001.1-1.1v-2.243a2.899 2.899 0 010-5.514V7A1.1 1.1 0 0019 5.9h-3.1V7a.9.9 0 01-1.8 0V5.9H5zm10 4.2a.9.9 0 01.9.9v2a.9.9 0 01-1.8 0v-2a.9.9 0 01.9-.9z"  /></Svg>;
}
export default TicketMedium;